import { createSlice } from "@reduxjs/toolkit"

const initialState = {}

const homePageSlice = createSlice({
  name: "homePage",
  initialState,
  reducers: {
    setHomePage: (state, action) => {
      // Merge the payload into state
      return { ...state, ...action.payload }
    }
  }
})

export const { setHomePage } = homePageSlice.actions
export default homePageSlice.reducer
